import React from "react";
import SecurityUtil from "../../../utils/SecurityUtils";

const ProcessComponent = props => {
  return (
    <>
      {SecurityUtil.partyHasAnyOfProcessesOrSameParty(
        props.processes,
        props.partyId
      ) && props.children}
    </>
  );
};

export default ProcessComponent;
